/* eslint no-shadow: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import AuditHistory from 'components/modules/shipments/AuditHistory';
import DataPoller from 'components/ui/DataPoller';
import { withTranslation } from 'react-i18next';
import CustomerStore from 'stores/CustomerSearchStore';
import CustomerActionCreators from 'actions/CustomersActionCreators';
import LabelValue from 'components/ui/tailwind/label-value';
import AccountContacts from 'components/v2/contacts';
import CargomaticCard from 'components/v2/card';
import CargomaticModal from 'components/v2/modal';
import CargomaticInput from 'components/v2/input';
import EditButton from '../../../v2/buttons/EditButton';
import Badge from '../../../v2/Badge';
import { Avatar } from '../Avatar';
const POLLING_FREQ = 10000;
const REQUIRED_ATTRIBUTES = [
    'first_name',
    'last_name',
    'username',
    'phone',
    'email',
];
const getRequiredAsterisk = (field) => {
    return REQUIRED_ATTRIBUTES.includes(field) ? '*' : '';
};
class VendorDetails extends Component {
    constructor(props) {
        super(props);
        this.isRequiredField = () => `${this.props.t('IS_REQUIRED_FIELD')}`;
        this.onAuditChange = () => {
            const audits = CustomerStore.getCustomerAudits();
            if (!_.isEqual(audits, this.state.audits)) {
                return this.setState({ audits });
            }
        };
        this.onSave = () => {
            const { changed, vendor } = this.state;
            _.map(changed, (item, key) => {
                if (!['badges', 'test'].includes(key)) {
                    if (vendor[key] && vendor[key] instanceof String) {
                        vendor[key] = vendor[key].trim();
                    }
                }
            });
            const updates = _.pick(vendor, Object.keys(changed));
            updates._id = vendor._id; // Didn't change but needed for the PATCH
            this.props.onSaveDetails('Vendor', updates);
        };
        this.getUserAudits = () => {
            CustomerActionCreators.fetchCustomerAudits(this.props.details._id);
        };
        this.handleFieldChange = (field, value) => {
            const { vendor, changed, errors } = this.state;
            vendor[field] = value;
            changed[field] = true;
            const { t } = this.props;
            errors[field] =
                !value && REQUIRED_ATTRIBUTES.includes(field)
                    ? { message: `${t(field.toUpperCase())} ${this.isRequiredField()}` }
                    : {};
            this.setState({ vendor, changed, errors });
        };
        this.renderAccountModal = () => {
            const { errors, vendor } = this.state;
            const { first_name, last_name, username, phone, email } = vendor;
            const { category } = this.state;
            const { t } = this.props;
            return (React.createElement("div", null,
                category === 'account' && (React.createElement("div", { className: "grid sm:grid-cols-6 sm:gap-4 gap-y-6" },
                    React.createElement(CargomaticInput, { className: "sm:col-span-3", error: errors.first_name, label: `${t('FIRST_NAME')} ${getRequiredAsterisk('first_name')}`, info: t('VENDOR_FIRST_NAME'), onChange: (value) => this.handleFieldChange('first_name', value), value: first_name }),
                    React.createElement(CargomaticInput, { className: "sm:col-span-3", error: errors.last_name, label: `${t('LAST_NAME')} ${getRequiredAsterisk('last_name')}`, info: t('VENDOR_LAST_NAME'), onChange: (value) => this.handleFieldChange('last_name', value), value: last_name }),
                    React.createElement(CargomaticInput, { className: "sm:col-span-3", error: errors.phone, label: `${t('PHONE_NUMBER')} ${getRequiredAsterisk('phone')}`, info: t('VENDOR_PHONE_NUMBER'), onChange: (value) => this.handleFieldChange('phone', value), value: phone }),
                    React.createElement(CargomaticInput, { className: "sm:col-span-4", error: errors.email, label: `${t('EMAIL_ADDRESS')} ${getRequiredAsterisk('email')}`, info: t('VENDOR_EMAIL'), onChange: (value) => this.handleFieldChange('email', value), value: email, maxLength: 254 }))),
                React.createElement("div", { className: "mt-4 form-actions" },
                    React.createElement("button", { className: "button button-green", onClick: this.onSave, disabled: this.errorsExist() }, t('SAVE')))));
        };
        this.state = {
            showAccountModal: false,
            category: null,
            vendor: props.details,
            audits: [],
            errors: {
                first_name: {},
                last_name: {},
                username: {},
                phone: {},
                email: {},
            },
            changed: {},
        };
    }
    componentDidMount() {
        CustomerStore.addAuditChangeListener(this.onAuditChange);
    }
    componentWillUnmount() {
        CustomerStore.removeAuditChangeListener(this.onAuditChange);
    }
    errorsExist() {
        const { errors } = this.state;
        let errorsExist = false;
        _.map(errors, (value, key) => {
            if (!_.isEmpty(errors[key]))
                errorsExist = true;
        });
        return errorsExist;
    }
    render() {
        const { vendor } = this.state;
        const { t } = this.props;
        return (React.createElement("div", { className: "mx-auto my-16 max-w-screen-2xl md:my-32 lg:my-16" },
            React.createElement(DataPoller, { action: this.getUserAudits, frequency: POLLING_FREQ }),
            React.createElement("div", { className: "lg:grid lg:grid-cols-4 lg:gap-6" },
                React.createElement("div", { className: "col-span-1" },
                    React.createElement(CargomaticCard, { className: "mb-6" },
                        React.createElement("div", { className: "text-center" },
                            React.createElement("div", { className: "flex justify-center py-6" },
                                React.createElement(Avatar, { key: vendor._id, userId: vendor._id, className: "h-32 w-32 cursor-pointer rounded-full" })),
                            React.createElement(Badge, { color: "blue" }, t('VENDOR', { count: 1 })),
                            React.createElement("div", { className: "flex justify-center py-6" },
                                React.createElement(LabelValue, { value: `${vendor.first_name} ${vendor.last_name}` })))),
                    React.createElement(CargomaticCard, { className: "mb-6", header: () => (React.createElement("header", { onClick: () => {
                                this.setState({
                                    category: 'account',
                                    showAccountModal: true,
                                });
                            }, className: "flex items-center justify-between" },
                            React.createElement("h3", { className: "my-0" }, t('ACCOUNT_DETAILS')),
                            React.createElement(EditButton, null))) },
                        React.createElement(LabelValue, { value: `${vendor.first_name} ${vendor.last_name}`, icon: "user" }),
                        React.createElement(LabelValue, { value: vendor.phone, icon: "phone" }),
                        React.createElement(LabelValue, { value: vendor.email, icon: "envelope" })),
                    React.createElement("div", { className: "mt-6" },
                        React.createElement("button", { className: "w-full button button-hollow-red", onClick: this.props.onChangePasswordClick }, t('CHANGE_PASSWORD')))),
                React.createElement("div", { className: "col-span-2" },
                    React.createElement(CargomaticCard, { className: "mb-6", header: () => React.createElement("h3", { className: "my-0" }, t('AUDIT_HISTORY')) },
                        React.createElement(AuditHistory, { audits: this.state.audits, paginate: true })),
                    React.createElement(CargomaticCard, null,
                        React.createElement(AccountContacts, { contacts: vendor.contacts, userId: vendor._id })))),
            this.state.showAccountModal && (React.createElement(CargomaticModal, { show: true, onHide: () => this.setState({ showAccountModal: false }), title: t('ACCOUNT_INFORMATION'), body: this.renderAccountModal(), footer: null, location: "middle" }))));
    }
}
VendorDetails.propTypes = {
    details: PropTypes.object,
    onSaveDetails: PropTypes.func.isRequired,
};
export default withTranslation()(VendorDetails);
